import { Component, ViewEncapsulation } from '@angular/core';
import { AbstractVerifyPhotoDirective } from '@directives/abstract-verify-photo.directive';
import { Photo } from '@models/photo';
import { TranslateModule } from '@ngx-translate/core';
import { PhotoHelpComponent } from '../photo-help/photo-help.component';
import { CloseOverlayKeyboardDirective } from '../../directives/close-overlay.directives';
import { CommonModule } from '@angular/common';
import { CameraFeedComponent } from '../camera-feed/camera-feed.component';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-verify-photo',
  styleUrls: ['verify-photo.component.scss'],
  templateUrl: 'verify-photo.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TranslateModule,
    PhotoHelpComponent,
    CloseOverlayKeyboardDirective,
    CameraFeedComponent,
    IconDirective
  ]
})
export class VerifyPhotoComponent extends AbstractVerifyPhotoDirective {
  handlePhoto(photo: Photo) {
    this.channel.perform('rebroadcast', { freshFacePhoto: photo.payload });
  }
}
